module.exports = __webpack_public_path__ + "img/title-1.b805808f.png";